import { generatedIconMap } from "./generated-icon-map";

export type GeneratedIconName = keyof typeof generatedIconMap;

export type IconSize = 20 | 16 | 24 | 32 | 48;

interface IconProps extends Omit<React.SVGProps<SVGSVGElement>, "width" | "height"> {
  name: GeneratedIconName;
  size?: IconSize;
}

export function Icon({ name, size = 20, ...props }: IconProps) {
  const Icon = generatedIconMap[name];
  return <Icon {...props} width={size} height={size} />;
}

// TODO: in the future if we need we can add similar support for custom icons with a `<CustomIcon />` component and a similar manually managed icon map
